import { format, parseISO } from "date-fns"

export function isISODate(dateString: string): boolean {
  const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?$/
  return isoRegex.test(dateString)
}

export function isDateTimeString(value: string): boolean {
  return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)
}

export function formatIsoDateToFullDate(dateString: string): string {
  return format(parseISO(dateString), "yyyy-MM-dd HH:mm")
}

export function formatFriendlyDateTime(dateString: string): string {
  // Parse ISO string directly to avoid timezone conversion issues
  const isoMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/)
  if (!isoMatch) return dateString

  const [, year, month, day, hours, minutes, seconds] = isoMatch
  const monthNum = parseInt(month, 10)
  const dayNum = parseInt(day, 10)
  const hoursNum = parseInt(hours, 10)
  const minutesNum = parseInt(minutes, 10)
  const secondsNum = parseInt(seconds, 10)

  // Get localized month name using Intl (respects browser locale)
  const tempDate = new Date(2000, monthNum - 1, 1)
  const monthName = new Intl.DateTimeFormat(undefined, { month: "short" }).format(tempDate)

  const isMidnight = hoursNum === 0 && minutesNum === 0 && secondsNum === 0
  const isEndOfDay = hoursNum === 23 && minutesNum === 59 && secondsNum === 59

  if (isMidnight || isEndOfDay) {
    return `${dayNum} ${monthName} ${year}`
  }

  return `${dayNum} ${monthName}, ${hours}:${minutes}`
}
